const useInsideURLs = () => {
    const onlinePlacementTestQuestions = "onlinePlacementTestQuestions";
    const onlinePlacementTests = "iStudyOnlinePlacementTest";
    const universityPrepProgrammes = "universityPrepProgrammes"
    const checks = "checks";
    const requestPrices = "requestPrices";
    const userRequests = "userRequests";
    const essayConversation = "essayConversation";
    const essayWorkPlace = "essayWorkPlace";
    const orders = "orders";
    const articles = "articles";
    const categories = "categories";
    const candidatetypes = "candidatetypes";
    const tags = "tags";
    const locations = "locations";
    const programs = "programs";
    const roles = "roles";
    const countries = "countries"
    const candidates = "candidates"
    const files = "files/upload"
    const residences = "residences"
    const genderschoolinformations = "genderschoolinformations"
    const schools = "schools"
    const celebrities = "celebrities"
    const faculties = "faculties"
    const universities = "universities"
    const clients = "clients"
    const leads = "leads"
    const users = "users"
    const languageLevelTests = "language-level-tests"
    const testUsers = "testUsers"
    const testUsersInformation = "testUsersInformation/get/:id"
    const mailingTypes = "mailingTypes"
    const headers = "header"
    const footers = "footer"
    const emailMessages = "emailMessages"
    const subscribers ="subscribers"
    const subscriberList = "subscriberList"
    const mailings = "mailing"
    const maillogs = "mailLog"
    const queue = "queue"
    const queueHistory = "queueHistory"
    const sender = "sender"
    const videos = "videos"
    const testTypes = "test-types"
    const essays = "essays"
    const products = "products"
    const languages = "languages"
    const globalSales = "global-sales"
    const mainCategoryTests = "main-category-tests"
    const cat4tests = "cat_4_test"
    const packs = "packs"
    const samples = "samples"
    const testArticles = "testArticles"
    const results = "results"
    const testPages = "testPages"
    const aiProducts = "aiProducts"
    const courses = "courses"

    return {onlinePlacementTestQuestions, onlinePlacementTests, aiProducts, testPages, universityPrepProgrammes, checks, requestPrices, results, testArticles, samples, packs, cat4tests, mainCategoryTests, userRequests, essayConversation, essayWorkPlace, orders, globalSales, languages, products, essays, testTypes, videos, sender, queueHistory, queue, maillogs, mailings, subscriberList, subscribers, emailMessages, footers, headers, mailingTypes, testUsersInformation, testUsers, languageLevelTests, users, leads, clients, articles, categories, candidatetypes, tags, locations, programs, roles, countries, candidates, files, residences, genderschoolinformations, schools, celebrities, faculties, universities, courses}

}

export default useInsideURLs;